import React from "react";

// DashboardIcon component
const DashboardIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00004 14.6667H10C13.3334 14.6667 14.6667 13.3333 14.6667 10V6C14.6667 2.66667 13.3334 1.33333 10 1.33333H6.00004C2.66671 1.33333 1.33337 2.66667 1.33337 6V10C1.33337 13.3333 2.66671 14.6667 6.00004 14.6667Z"
      stroke="#A3A3A3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M4.58667 12.1V10.72" stroke="#A3A3A3" stroke-linecap="round" />
    <path d="M8 12.1V9.33997" stroke="#A3A3A3" stroke-linecap="round" />
    <path d="M11.4133 12.1V7.95337" stroke="#A3A3A3" stroke-linecap="round" />
    <path
      d="M11.4133 3.90002L11.1067 4.26002C9.40667 6.24669 7.12667 7.65336 4.58667 8.28669"
      stroke="#A3A3A3"
      stroke-linecap="round"
    />
    <path
      d="M9.45996 3.90002H11.4133V5.84669"
      stroke="#A3A3A3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

// UserManagementIcon component
const UserManagementIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.10671 7.24667C6.04004 7.24 5.96004 7.24 5.88671 7.24667C4.30004 7.19334 3.04004 5.89334 3.04004 4.29334C3.04004 2.66 4.36004 1.33334 6.00004 1.33334C7.63337 1.33334 8.96004 2.66 8.96004 4.29334C8.95337 5.89334 7.69337 7.19334 6.10671 7.24667Z"
      stroke="#A3A3A3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.9401 2.66666C12.2334 2.66666 13.2734 3.71333 13.2734 5C13.2734 6.26 12.2734 7.28666 11.0267 7.33333C10.9734 7.32666 10.9134 7.32666 10.8534 7.33333"
      stroke="#A3A3A3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.77335 9.70666C1.16002 10.7867 1.16002 12.5467 2.77335 13.62C4.60669 14.8467 7.61335 14.8467 9.44669 13.62C11.06 12.54 11.06 10.78 9.44669 9.70666C7.62002 8.48666 4.61335 8.48666 2.77335 9.70666Z"
      stroke="#A3A3A3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.2267 13.3333C12.7067 13.2333 13.16 13.04 13.5334 12.7533C14.5734 11.9733 14.5734 10.6867 13.5334 9.90667C13.1667 9.62667 12.72 9.44 12.2467 9.33334"
      stroke="#A3A3A3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const TransactionIcon = () => (
  <svg
    fill="#fff"
    width="18px"
    height="18px"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        stroke="#A3A3A3"
        d="M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 0 1 103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 0 1-103.5 242.4 352.57 352.57 0 0 1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 0 1-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z"
      ></path>
      <path
        stroke="#A3A3A3"
        d="M558.2 534.4c0 4.7 3.8 8.5 8.5 8.5s8.5-3.8 8.5-8.5V502c0-4.7-3.8-8.5-8.5-8.5s-8.5 3.8-8.5 8.5v32.4zM560.2 553.8h4.1c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5h-4.1c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5zM568.7 508.3c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5zM487.6 573.2c0 4.7 3.8 8.5 8.5 8.5s8.5-3.8 8.5-8.5v-31.9c0-4.7-3.8-8.5-8.5-8.5s-8.5 3.8-8.5 8.5v31.9zM489.7 613.5h4.1c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5h-4.1c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5zM498.2 568.1c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5zM517.3 603c0 4.7 3.8 8.5 8.5 8.5s8.5-3.8 8.5-8.5v-31.9c0-4.7-3.8-8.5-8.5-8.5s-8.5 3.8-8.5 8.5v31.9zM519.3 643.3h4.1c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5h-4.1c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5zM527.8 597.9c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5zM428.2 576c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5S432.9 576 428.2 576z"
        fill="#fff"
      ></path>
    </g>
  </svg>
);
// TemplateManagementIcon component
const TemplateManagementIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2133 8C13.9467 8 14.6667 7.33333 14.0267 5.14667C13.5933 3.67333 12.3267 2.40667 10.8533 1.97333C8.66667 1.33333 8 2.05333 8 3.78667V5.70667C8 7.33333 8.66667 8 10 8H12.2133Z"
      stroke="#A3A3A3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3333 9.8C12.7133 12.8867 9.75333 15.1267 6.38666 14.58C3.85999 14.1733 1.82666 12.14 1.41333 9.61333C0.873327 6.26 3.09999 3.3 6.17333 2.67333"
      stroke="#A3A3A3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

// InterviewDashboardIcon component
const InterviewDashboardIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1066 13.2466C12.04 13.24 11.96 13.24 11.8866 13.2466C10.3 13.1933 9.03998 11.8933 9.03998 10.2933C9.03998 8.65998 10.36 7.33331 12 7.33331C13.6333 7.33331 14.96 8.65998 14.96 10.2933C14.9533 11.8933 13.6933 13.1933 12.1066 13.2466Z"
      stroke="#0052CC"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.94 8.66669C18.2333 8.66669 19.2733 9.71335 19.2733 11C19.2733 12.26 18.2733 13.2867 17.0267 13.3334C16.9733 13.3267 16.9133 13.3267 16.8533 13.3334"
      stroke="#0052CC"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.77335 15.7067C7.16002 16.7867 7.16002 18.5467 8.77335 19.62C10.6067 20.8467 13.6134 20.8467 15.4467 19.62C17.06 18.54 17.06 16.78 15.4467 15.7067C13.62 14.4867 10.6134 14.4867 8.77335 15.7067Z"
      stroke="#0052CC"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.2267 19.3333C18.7067 19.2333 19.16 19.04 19.5334 18.7533C20.5734 17.9733 20.5734 16.6866 19.5334 15.9066C19.1667 15.6266 18.72 15.44 18.2467 15.3333"
      stroke="#0052CC"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

// InterviewCallRecordIcon component
const InterviewCallRecordIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1066 13.2466C12.04 13.24 11.96 13.24 11.8866 13.2466C10.3 13.1933 9.03998 11.8933 9.03998 10.2933C9.03998 8.65998 10.36 7.33331 12 7.33331C13.6333 7.33331 14.96 8.65998 14.96 10.2933C14.9533 11.8933 13.6933 13.1933 12.1066 13.2466Z"
      stroke="#0052CC"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.94 8.66669C18.2333 8.66669 19.2733 9.71335 19.2733 11C19.2733 12.26 18.2733 13.2867 17.0267 13.3334C16.9733 13.3267 16.9133 13.3267 16.8533 13.3334"
      stroke="#0052CC"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.77335 15.7067C7.16002 16.7867 7.16002 18.5467 8.77335 19.62C10.6067 20.8467 13.6134 20.8467 15.4467 19.62C17.06 18.54 17.06 16.78 15.4467 15.7067C13.62 14.4867 10.6134 14.4867 8.77335 15.7067Z"
      stroke="#0052CC"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.2267 19.3333C18.7067 19.2333 19.16 19.04 19.5334 18.7533C20.5734 17.9733 20.5734 16.6866 19.5334 15.9066C19.1667 15.6266 18.72 15.44 18.2467 15.3333"
      stroke="#0052CC"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

// Settings Icon
const SettingsIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke="#A3A3A3"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.33337 8.58667V7.41333C1.33337 6.72 1.90004 6.14667 2.60004 6.14667C3.80671 6.14667 4.30004 5.29333 3.69337 4.24667C3.34671 3.64667 3.55337 2.86667 4.16004 2.52L5.31337 1.86C5.84004 1.54666 6.52004 1.73333 6.83337 2.26L6.90671 2.38666C7.50671 3.43333 8.49337 3.43333 9.10004 2.38666L9.17337 2.26C9.48671 1.73333 10.1667 1.54666 10.6934 1.86L11.8467 2.52C12.4534 2.86667 12.66 3.64667 12.3134 4.24667C11.7067 5.29333 12.2 6.14667 13.4067 6.14667C14.1 6.14667 14.6734 6.71333 14.6734 7.41333V8.58667C14.6734 9.28 14.1067 9.85333 13.4067 9.85333C12.2 9.85333 11.7067 10.7067 12.3134 11.7533C12.66 12.36 12.4534 13.1333 11.8467 13.48L10.6934 14.14C10.1667 14.4533 9.48671 14.2667 9.17337 13.74L9.10004 13.6133C8.50004 12.5667 7.51337 12.5667 6.90671 13.6133L6.83337 13.74C6.52004 14.2667 5.84004 14.4533 5.31337 14.14L4.16004 13.48C3.55337 13.1333 3.34671 12.3533 3.69337 11.7533C4.30004 10.7067 3.80671 9.85333 2.60004 9.85333C1.90004 9.85333 1.33337 9.28 1.33337 8.58667Z"
      stroke="#A3A3A3"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const EventIcon = () => (
  <svg
    fill="#cfcaca"
    version="1.1"
    id="Layer_1"
    width="18px"
    height="18px"
    viewBox="0 0 253.00 253.00"
    enable-background="new 0 0 253 260"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="#A3A3A3"
      stroke-width="1.012"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        stroke="#A3A3A3"
        d="M194.221,2c-5.959,0-10.814,4.855-10.814,10.814V46.8c0,5.959,4.855,10.814,10.814,10.814s10.814-4.855,10.814-10.814 V12.814C205.035,6.855,200.179,2,194.221,2 M250.938,33.338v57.159V258H2V90.276V33.338h33.766v13.683 c0,12.579,10.152,22.952,22.952,22.952C71.297,69.972,81.669,59.6,81.669,47.021V33.338h89.6v13.683 c0,12.579,10.372,22.952,22.952,22.952c12.579,0,22.952-10.372,22.952-22.952V33.338H250.938z M237.476,90.497H15.462v153.6h172.579 l49.434-48.772V90.497H237.476z M58.717,2c-5.958,0-10.814,4.855-10.814,10.814V46.8c0,5.959,4.855,10.814,10.814,10.814 c5.959,0,10.814-4.855,10.814-10.814V12.814C69.531,6.855,64.676,2,58.717,2 M194.221,2c-5.959,0-10.814,4.855-10.814,10.814V46.8 c0,5.959,4.855,10.814,10.814,10.814s10.814-4.855,10.814-10.814V12.814C205.035,6.855,200.179,2,194.221,2 M114.175,222.938 l-53.158-53.159l21.213-21.213l31.976,31.976l59.594-59.423l21.184,21.244L114.175,222.938z"
      ></path>
    </g>
  </svg>
);

const RefundIcon = () => (
  <svg
    fill="#fafafa"
    height="18px"
    width="18px"
    version="1.1"
    id="Layer_1"
    viewBox="0 0 193.769 193.769"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g>
        <g>
          <g>
            <path
              stroke="#A3A3A3"
              d="M149.203,41.104l-9.348,12.009c20.15,15.679,30.201,41.063,26.234,66.253c-2.906,18.484-12.838,34.73-27.964,45.748 c-15.131,11.012-33.64,15.488-52.124,12.567c-38.157-6.008-64.32-41.938-58.322-80.098C30.585,79.097,40.52,62.85,55.648,51.835 c13.208-9.615,28.991-14.233,45.086-13.317L87.579,52.319l9.759,9.313l20.766-21.801l0.005,0.008l9.303-9.769l-9.752-9.303 l-0.005,0.003L95.862,0l-9.31,9.769l14.2,13.525c-19.303-0.913-38.21,4.702-54.059,16.242 C28.28,52.943,16.19,72.717,12.65,95.221c-7.302,46.445,24.54,90.184,70.985,97.493c4.489,0.708,8.976,1.055,13.434,1.055 c17.89,0,35.273-5.623,50.011-16.356c18.415-13.409,30.503-33.183,34.043-55.682C185.952,91.077,173.72,60.181,149.203,41.104z"
            ></path>
            <path
              stroke="#A3A3A3"
              d="M105.24,151.971v-0.003h0.001v-8.757c10.383-1.159,20.485-7.718,20.485-20.17c0-16.919-15.732-18.859-27.223-20.274 c-7.347-0.878-12.97-1.897-12.97-6.348c0-6.188,8.722-6.855,12.473-6.855c5.567,0,11.507,2.617,13.525,5.957l0.586,0.971 l11.542-5.341l-0.571-1.164c-4.301-8.793-12.009-11.337-17.85-12.364v-7.71H91.723v7.677 c-12.582,1.856-20.054,8.839-20.054,18.829c0,16.29,14.791,17.943,25.582,19.153c9.617,1.134,14.094,3.51,14.094,7.469 c0,7.563-10.474,8.154-13.685,8.154c-7.147,0-14.038-3.566-16.031-8.301l-0.495-1.169l-12.539,5.316l0.5,1.169 c3.713,8.691,11.725,14.137,22.63,15.425v8.336H105.24z"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const PasswordIcon = () => (
<svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="#fafdfa">
	<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
	<g id="SVGRepo_iconCarrier">
		<g id="Layer_2" data-name="Layer 2">
			<g id="invisible_box" data-name="invisible box">
				<rect width="18" height="18" fill="none"></rect>
			</g>
			<g id="Layer_7" data-name="Layer 7">
				<g>
					<path
            stroke="#A3A3A3"
						d="M39,18H35V13A11,11,0,0,0,24,2H22A11,11,0,0,0,11,13v5H7a2,2,0,0,0-2,2V44a2,2,0,0,0,2,2H39a2,2,0,0,0,2-2V20A2,2,0,0,0,39,18ZM15,13a7,7,0,0,1,7-7h2a7,7,0,0,1,7,7v5H15ZM37,42H9V22H37Z">
					</path>
					<circle cx="15" cy="32" r="3"></circle>
					<circle cx="23" cy="32" r="3"></circle>
					<circle cx="31" cy="32" r="3"></circle>
				</g>
			</g>
		</g>
	</g>
</svg>
);

const AdsIcon = () => (
  <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.048">
	</g>
	<g id="SVGRepo_iconCarrier">
		<path
			d="M5 5H19C20.1046 5 21 5.89543 21 7V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V7C3 5.89543 3.89543 5 5 5Z"
			stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
		<path d="M7 15V11C7 9.89543 7.89543 9 9 9V9C10.1046 9 11 9.89543 11 11V15" stroke="#323232" stroke-width="2"
			stroke-linecap="round" stroke-linejoin="round"></path>
		<path d="M17 9V15" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
		<path d="M17 12H15.5C13.5 12 13.5 15 15.5 15H17" stroke="#323232" stroke-width="2" stroke-linecap="round"
			stroke-linejoin="round"></path>
		<path d="M7 13H11" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
	</g>
</svg>
)

const ExpenseIcon = () => (
  <svg width="16px" height="16px" viewBox="0 0 24 24" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
	<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
	<g id="SVGRepo_iconCarrier">
		<path fill="none" stroke="#020202" stroke-miterlimit="10" stroke-width="1.91px" d="M12,12H22.5a10.45,10.45,0,0,1-3.07,7.42L12,12V1.48A10.5,10.5,0,1,0,19.43,19.4"></path>
		<path fill="none" stroke="#020202" stroke-miterlimit="10" stroke-width="1.91px"
			d="M15.82,8.16h3.34a1.43,1.43,0,0,0,1.43-1.43h0A1.43,1.43,0,0,0,19.16,5.3h-1a1.44,1.44,0,0,1-1.43-1.44h0A1.43,1.43,0,0,1,18.2,2.43h3.35">
		</path>
		<line fill="none" stroke="#020202" stroke-miterlimit="10" stroke-width="1.91px" x1="18.68" y1="0.52" x2="18.68" y2="2.43"></line>
		<line fill="none" stroke="#020202" stroke-miterlimit="10" stroke-width="1.91px" x1="18.68" y1="8.16" x2="18.68" y2="10.07"></line>
	</g>
</svg>
)


const FeesIcon = () => (
  <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
	<g id="SVGRepo_iconCarrier">
		<circle cx="12" cy="12" r="10" stroke="#A3A3A3" stroke-width="1.5"></circle>
		<path d="M12 6V18" stroke="#A3A3A3" stroke-width="1.5" stroke-linecap="round"></path>
		<path
			d="M15 9.5C15 8.11929 13.6569 7 12 7C10.3431 7 9 8.11929 9 9.5C9 10.8807 10.3431 12 12 12C13.6569 12 15 13.1193 15 14.5C15 15.8807 13.6569 17 12 17C10.3431 17 9 15.8807 9 14.5"
			stroke="#A3A3A3" stroke-width="1.5" stroke-linecap="round"></path>
	</g>
</svg>
)

const InterviewSlotIcon = () => (
  <svg fill="#ffffff" width="18px" height="18px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
	<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
	<g id="SVGRepo_iconCarrier">
		<path
      stroke="#A3A3A3"
			d="M960 95.888l-256.224.001V32.113c0-17.68-14.32-32-32-32s-32 14.32-32 32v63.76h-256v-63.76c0-17.68-14.32-32-32-32s-32 14.32-32 32v63.76H64c-35.344 0-64 28.656-64 64v800c0 35.343 28.656 64 64 64h896c35.344 0 64-28.657 64-64v-800c0-35.329-28.656-63.985-64-63.985zm0 863.985H64v-800h255.776v32.24c0 17.679 14.32 32 32 32s32-14.321 32-32v-32.224h256v32.24c0 17.68 14.32 32 32 32s32-14.32 32-32v-32.24H960v799.984zM736 511.888h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32zm0 255.984h64c17.664 0 32-14.32 32-32v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.696 14.336 32 32 32zm-192-128h-64c-17.664 0-32 14.336-32 32v64c0 17.68 14.336 32 32 32h64c17.664 0 32-14.32 32-32v-64c0-17.648-14.336-32-32-32zm0-255.984h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.68-14.336-32-32-32zm-256 0h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.68-14.336-32-32-32zm0 255.984h-64c-17.664 0-32 14.336-32 32v64c0 17.68 14.336 32 32 32h64c17.664 0 32-14.32 32-32v-64c0-17.648-14.336-32-32-32z">
		</path>
	</g>
</svg>
)

const InterviewIcon = () => (
  <svg fill="#fff" viewBox="0 0 64 64"
  stroke="#A3A3A3"
	>
	<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
	<g id="SVGRepo_iconCarrier">
		<g id="ICON">
			<path
				d="M29,12l0,3l-23,0c-0.796,0 -1.559,0.316 -2.121,0.879c-0.563,0.562 -0.879,1.325 -0.879,2.121c0,2.509 0,8.581 0,13.5c0,0.552 0.448,1 1,1c0.552,0 1,-0.448 1,-1l0,-13.5c-0,-0.265 0.105,-0.52 0.293,-0.707c0.187,-0.188 0.442,-0.293 0.707,-0.293c0,0 52,0 52,0c0.265,0 0.52,0.105 0.707,0.293c0.188,0.187 0.293,0.442 0.293,0.707l0,25l-14.512,0c0.133,-3.365 -1.083,-6.773 -3.649,-9.339c-1.386,-1.386 -3.018,-2.378 -4.755,-2.976c1.765,-1.272 2.916,-3.345 2.916,-5.685c0,-3.863 -3.137,-7 -7,-7c-3.863,0 -7,3.137 -7,7c0,2.34 1.151,4.413 2.916,5.685c-1.737,0.598 -3.369,1.59 -4.755,2.976c-2.566,2.566 -3.782,5.974 -3.649,9.339l-14.512,0l0,-8c0,-0.552 -0.448,-1 -1,-1c-0.552,0 -1,0.448 -1,1l0,13c-0,0.796 0.316,1.559 0.879,2.121c0.562,0.563 1.325,0.879 2.121,0.879l4,0c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1l-4,0c-0.265,-0 -0.52,-0.105 -0.707,-0.293c-0.188,-0.187 -0.293,-0.442 -0.293,-0.707l0,-3l54,0l0,3c0,0.265 -0.105,0.52 -0.293,0.707c-0.187,0.188 -0.442,0.293 -0.707,0.293l-44,0c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1l12.606,0c-0.16,2.682 -0.855,6.147 -3.417,8l-1.689,0c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1l21,0c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1l-1.689,0c-2.562,-1.854 -3.257,-5.318 -3.417,-8l20.606,0c0.796,-0 1.559,-0.316 2.121,-0.879c0.563,-0.562 0.879,-1.325 0.879,-2.121c0,-6.028 0,-23.972 0,-30c0,-0.796 -0.316,-1.559 -0.879,-2.121c-0.562,-0.563 -1.325,-0.879 -2.121,-0.879l-23,0l-0,-3l3,0c1.657,-0 3,-1.343 3,-3l-0,-3c-0,-1.657 -1.343,-3 -3,-3l-12,0c-1.657,0 -3,1.343 -3,3c0,0.941 0,2.059 0,3c0,1.657 1.343,3 3,3l3,-0Zm6.394,39l-6.788,0c-0.155,2.531 -0.785,5.68 -2.585,8l11.958,0c-1.8,-2.32 -2.43,-5.47 -2.585,-8Zm-7.974,-17.951c-1.028,0.498 -1.992,1.174 -2.845,2.026c-2.165,2.165 -3.185,5.044 -3.063,7.882c0.001,0.014 0.001,0.029 0.001,0.043l20.974,0c-0,-0.014 0,-0.029 0.001,-0.043c0.122,-2.838 -0.898,-5.717 -3.063,-7.882c-0.853,-0.852 -1.817,-1.528 -2.845,-2.026c-0.19,0.834 -0.609,1.625 -1.258,2.273c-1.833,1.834 -4.811,1.834 -6.644,0c-0.649,-0.648 -1.068,-1.439 -1.258,-2.273Zm-20.42,2.951l0,2c0,0.552 0.448,1 1,1c0.552,-0 1,-0.448 1,-1l0,-2c0,-0.552 -0.448,-1 -1,-1c-0.552,-0 -1,0.448 -1,1Zm27.675,-3.654c-1.751,-0.459 -3.599,-0.459 -5.35,0c0.073,0.572 0.329,1.124 0.767,1.562c1.053,1.053 2.763,1.053 3.816,0c0.438,-0.438 0.694,-0.99 0.767,-1.562Zm-25.675,0.654l0,-13c0,-0.552 -0.448,-1 -1,-1c-0.552,-0 -1,0.448 -1,1l0,13c0,0.552 0.448,1 1,1c0.552,-0 1,-0.448 1,-1Zm23,-13c2.76,-0 5,2.24 5,5c0,2.76 -2.24,5 -5,5c-2.76,-0 -5,-2.24 -5,-5c0,-2.76 2.24,-5 5,-5Zm-1,-8l1.451,-0l0.549,0l-0,3l-2,0l-0,-3Zm8,-6l0,3c-0,0.552 -0.448,1 -1,1c-0,0 -12,-0 -12,-0c-0.552,-0 -1,-0.448 -1,-1c0,-0 -0,-3 -0,-3c0,-0.552 0.448,-1 1,-1c0,0 12,0 12,0c0.552,0 1,0.448 1,1Zm-3,0.5c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1Zm-8,0c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1Z">
        stroke="#A3A3A3"
        </path>
		</g>
	</g>
</svg>
)


const InterviewCallIcon = () => (
  <svg width="18px" height="18px"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
	<g id="SVGRepo_iconCarrier">
		<path
			d="M17 12C19.7614 12 22 9.76142 22 7C22 4.23858 19.7614 2 17 2C14.2386 2 12 4.23858 12 7C12 7.79984 12.1878 8.55582 12.5217 9.22624C12.6105 9.4044 12.64 9.60803 12.5886 9.80031L12.2908 10.9133C12.1615 11.3965 12.6035 11.8385 13.0867 11.7092L14.1997 11.4114C14.392 11.36 14.5956 11.3895 14.7738 11.4783C15.4442 11.8122 16.2002 12 17 12Z"
			stroke="#ebeaea" stroke-width="1.5"></path>
		<path d="M15 7H19M17 9L17 5" stroke="#ebeaea" stroke-width="1.5" stroke-linecap="round"></path>
		<path
			d="M8.03759 7.31617L8.6866 8.4791C9.2723 9.52858 9.03718 10.9053 8.11471 11.8278C8.11471 11.8278 8.11471 11.8278 8.11471 11.8278C8.11459 11.8279 6.99588 12.9468 9.02451 14.9755C11.0525 17.0035 12.1714 15.8861 12.1722 15.8853C12.1722 15.8853 12.1722 15.8853 12.1722 15.8853C13.0947 14.9628 14.4714 14.7277 15.5209 15.3134L16.6838 15.9624C18.2686 16.8468 18.4557 19.0692 17.0628 20.4622C16.2258 21.2992 15.2004 21.9505 14.0669 21.9934C12.1588 22.0658 8.91828 21.5829 5.6677 18.3323C2.41713 15.0817 1.93421 11.8412 2.00655 9.93309C2.04952 8.7996 2.7008 7.77423 3.53781 6.93723C4.93076 5.54428 7.15317 5.73144 8.03759 7.31617Z"
			stroke="#ebeaea" stroke-width="1.5" stroke-linecap="round"></path>
	</g>
</svg>
)

const Miscellaneous = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.16768 11.2402V12.5936C7.16768 13.7403 6.10101 14.6669 4.78768 14.6669C3.47435 14.6669 2.401 13.7403 2.401 12.5936V11.2402C2.401 12.3869 3.46768 13.2002 4.78768 13.2002C6.10101 13.2002 7.16768 12.3802 7.16768 11.2402Z" stroke="#A3A3A3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M7.16663 9.40662C7.16663 9.73995 7.07329 10.0466 6.91329 10.3133C6.51996 10.9599 5.71328 11.3666 4.77995 11.3666C3.84661 11.3666 3.03994 10.9533 2.64661 10.3133C2.48661 10.0466 2.39331 9.73995 2.39331 9.40662C2.39331 8.83328 2.65996 8.31995 3.08663 7.94661C3.51996 7.56661 4.11327 7.33997 4.77327 7.33997C5.43327 7.33997 6.02663 7.57328 6.45996 7.94661C6.89996 8.31328 7.16663 8.83328 7.16663 9.40662Z" stroke="#A3A3A3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M7.16768 9.4067V11.24C7.16768 12.3867 6.10101 13.2 4.78768 13.2C3.47435 13.2 2.401 12.38 2.401 11.24V9.4067C2.401 8.26003 3.46768 7.33337 4.78768 7.33337C5.44768 7.33337 6.04103 7.56669 6.47436 7.94002C6.90103 8.31336 7.16768 8.83336 7.16768 9.4067Z" stroke="#A3A3A3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6667 7.31327V8.68665C14.6667 9.05331 14.3734 9.35328 14.0001 9.36662H12.6934C11.9734 9.36662 11.3134 8.83995 11.2534 8.11995C11.2134 7.69995 11.3734 7.30662 11.6534 7.03328C11.9 6.77995 12.24 6.6333 12.6134 6.6333H14.0001C14.3734 6.64663 14.6667 6.94661 14.6667 7.31327Z" stroke="#A3A3A3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M1.33337 7.00004V5.66671C1.33337 3.85337 2.42671 2.58671 4.12671 2.37337C4.30004 2.34671 4.48004 2.33337 4.66671 2.33337H10.6667C10.84 2.33337 11.0067 2.34003 11.1667 2.3667C12.8867 2.5667 14 3.84004 14 5.66671V6.63338H12.6134C12.24 6.63338 11.9 6.78003 11.6534 7.03337C11.3734 7.3067 11.2134 7.70004 11.2534 8.12004C11.3134 8.84004 11.9734 9.3667 12.6934 9.3667H14V10.3334C14 12.3334 12.6667 13.6667 10.6667 13.6667H9.00004" stroke="#A3A3A3" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export {
  DashboardIcon,
  UserManagementIcon,
  TemplateManagementIcon,
  InterviewDashboardIcon,
  InterviewCallRecordIcon,
  SettingsIcon,
  EventIcon,
  TransactionIcon,
  RefundIcon,
  PasswordIcon,
  AdsIcon,
  ExpenseIcon,
  FeesIcon,
  InterviewIcon,
  InterviewCallIcon,
  InterviewSlotIcon,
  Miscellaneous
};
